<template>
  <div>
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..." /></div>
    </div>
    <div
      v-else-if="
        $auth.check(['dashboard.accounts']) && dsr_payment_method === 1
      "
    >
      <!-- Dados sobre Pontos -->

      <div
        v-if="!isWithinRescuePeriod"
        class="button-container"
        id="container-contact"
      >
        <div class="button-container" id="container-contact">
          <div class="container">
            <div class="row align-items-center">
              <div class="message-section" id="align-center">
                <div class="flex-container-emissao" id="no-pad-left">
                  <h2 class="close-request">Requisições fechadas</h2>
                  <img
                    src="img/requisicoes_fechadas.png"
                    alt="Fechado"
                    class="icon-size"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div id="movpoints">
          <h1 style="text-transform: uppercase; text-align: left">
            Trocar pontos via entidade patronal
          </h1>
          <div class="card-list">
            <div class="card">
              <div class="card-content">
                <h4
                  style="
                    margin-bottom: 0;
                    background-color: #f48c4f;
                    color: white;
                    padding: 12px;
                    border-radius: 10px;
                    max-width: 75%;
                  "
                >
                  Mês: {{ formattedDate }}
                </h4>

                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    margin-bottom: 0;
                    height: 20px;
                  "
                >
                  <p style="font-weight: bold">Pontos UFS:</p>
                  <p style="font-weight: bold">{{ points.ufs.original }}</p>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0;
                    height: 20px;
                  "
                >
                  <p style="font-weight: bold">Pontos OLA:</p>
                  <p style="font-weight: bold">{{ points.ola.original }}</p>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0;
                    height: 20px;
                    margin-top: 20px;
                  "
                >
                  <p>Total:</p>
                  <p style="font-weight: bold; color: #f48c4f">
                    {{ totalPoints }}
                  </p>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0;
                    height: 20px;
                  "
                >
                  <p></p>
                  <p style="font-size: 14px">equivalente a {{ totalValue }}€</p>
                </div>
                <div class="input">
                  <div style="margin-top: 20px; flex: 1">
                    <label
                      for="ufsInput"
                      style="
                        font-weight: bold;
                        /* display: block; */
                        margin-bottom: 5px;
                        text-align: center;
                      "
                      >UFS</label
                    >
                    <input
                      id="ufsInput"
                      type="number"
                      min="2000"
                      :disabled="points.ufs.original < 2000"
                      :max="points.ufs.original"
                      v-model.number="pointsToTradeUfs"
                      @input="handleUfsInput"
                    />
                    <small
                      v-if="points.ufs.original < 2000"
                      style="color: black"
                    >
                      Não tem pontos UFS suficientes para trocar (min: 2000
                      pontos).
                    </small>
                  </div>
                  <div style="margin-top: 20px; flex: 1">
                    <label
                      for="olaInput"
                      style="
                        font-weight: bold;
                        display: block;
                        margin-bottom: 5px;
                        text-align: center;
                      "
                      >OLA</label
                    >
                    <input
                      id="olaInput"
                      type="number"
                      min="2000"
                      :disabled="points.ola.original < 2000"
                      :max="points.ola.original"
                      v-model.number="pointsToTradeOla"
                      @input="handleOlaInput"
                    />
                    <small
                      v-if="points.ola.original < 2000"
                      style="color: black"
                    >
                      Não tem pontos OLA suficientes para trocar (min: 2000
                      pontos).
                    </small>
                  </div>
                </div>
                <div v-if="requestedPointsTotal > 0" style="margin-top: 20px">
                  <p style="font-weight: bold">
                    Total a trocar: {{ requestedPointsTotal }} pontos
                  </p>
                  <p style="font-size: 14px">
                    Equivalente a: {{ requestedPointsValue }}€
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 20px; text-align: right">
          <button
            @click="submitPointsExchange"
            :disabled="isSubmitting"
            :style="{
              padding: '10px 20px',
              backgroundColor: '#f48c4f',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              opacity: isSubmitting ? 0.6 : 1,
            }"
          >
            Submeter pontos
          </button>
          <div v-if="isFeedbackModalOpen" class="modal-overlay">
            <div class="modal-content">
              <h3 class="modal-h3">{{ feedbackTitle }}</h3>
              <p class="modal-p">{{ feedbackMessage }}</p>
              <button
                v-if="isErrorFeedback"
                @click="isFeedbackModalOpen = false"
                class="btn-close"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue@2.6.14/dist/vue.js"></script>
<script>
import axios from "axios"; // Import axios here
import Vue from "vue";
import VModal from "vue-js-modal";
import "vue-js-modal/dist/styles.css";

Vue.use(VModal);

export default {
  name: "emissao",
  components: {},
  data() {
    return {
      pointsToTradeUfs: null,
      isSubmitting: false,
      pointsToTradeOla: null,
      points_release: null,
      rescue_limit: null,
      requesitions: null,
      points: {
        ufs: { headers: [], original: 0, exception: null },
        ola: { headers: [], original: 0, exception: null },
      },
      state: {
        estado: "Não Submetido",
      },
      submissionStateCode: null,
      isolatedState: null,
      showModal: false,
      isModalOpen: false,
      isErrorFeedback: false,
      isFeedbackModalOpen: false,
      feedbackTitle: "",
      feedbackMessage: "",
      image: null,
      data: null,
      loading: true,
      user: null,
      points: null,
      fileName: "", // Track the file name
      docs: null,
      hasLoadedMore: false,
      isLeader: false,
      user_id: null,
      dsr_id: null,
      dsr_payment_method: null,
      uploadedFile: null,
    };
  },

  computed: {
    totalPoints() {
      return (
        ((this.points && this.points.ufs && this.points.ufs.original) || 0) +
        ((this.points && this.points.ola && this.points.ola.original) || 0)
      );
    },

    isWithinRescuePeriod() {
      if (!this.rescue_limit) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0); // reset time

      const limitDate = new Date(this.rescue_limit);
      limitDate.setHours(0, 0, 0, 0);

      console.log("Today:", today);
      console.log("Rescue limit:", limitDate);
      console.log("Comparison result:", today <= limitDate);

      return today <= limitDate;
    },

    totalValue() {
      let total = 0.01 * this.totalPoints;
      let rounded = total.toFixed(2);
      return rounded;
    },

    requestedPointsTotal() {
      return (this.pointsToTradeUfs || 0) + (this.pointsToTradeOla || 0);
    },
    requestedPointsValue() {
      return (this.requestedPointsTotal * 0.01).toFixed(2);
    },

    formattedDate() {
      const months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      if (!this.points_release || this.points_release.length !== 6) return "";

      const year = this.points_release.slice(0, 4);
      const monthIndex = parseInt(this.points_release.slice(4, 6), 10) - 1;

      const monthName = months[monthIndex] || "";
      return `${monthName} de ${year}`;
    },
  },

  async mounted() {
    try {
      this.loading = true;
      await Promise.all([
        this.fetchPointsPatronal(),
        // this.closeRequest(),
        this.fetchDsrId(),
        this.fetchName(),
        this.formatName(),
      ]);
      this.loading = false;
    } catch (error) {
      console.error("Error during initialization:", error);
      this.loading = false;
    }
  },

  methods: {
    handleUfsInput(e) {
      const val = parseInt(e.target.value, 10);
      const max = this.points.ufs.original;

      if (!isNaN(val) && val <= max) {
        this.pointsToTradeUfs = val;
      } else if (val > max) {
        this.pointsToTradeUfs = max;
      } else {
        this.pointsToTradeUfs = "";
      }
    },
    handleOlaInput(e) {
      const val = parseInt(e.target.value, 10);
      const max = this.points.ola.original;

      if (!isNaN(val) && val <= max) {
        this.pointsToTradeOla = val;
      } else if (val > max) {
        this.pointsToTradeOla = max;
      } else {
        this.pointsToTradeOla = "";
      }
    },

    async fetchPointsPatronal() {
      try {
        const response = await axios.get(`app/getLimit`);

        if (response.status === 200 && response.data) {
          const { ufs, ola, points_release, rescue_limit, requisitions } =
            response.data;

          // Validate the structure before assigning
          this.points = {
            ufs: ufs || { headers: [], original: 0, exception: null },
            ola: ola || { headers: [], original: 0, exception: null },
          };
          this.points_release = String(points_release);
          this.rescue_limit = rescue_limit;
          this.requesitions = requisitions;
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    formatName(fullName) {
      if (!fullName) return ""; // Retorna vazio se o nome não existir
      const names = fullName.trim().split(" ");
      if (names.length === 1) return names[0]; // Apenas um nome
      return `${names[0]} ${names[names.length - 1]}`; // Primeiro e último
    },

    getRunningBalance(index) {
      // Start with saldoOla as the base
      let balance = this.saldo;

      // Sum the total_points up to the current index
      for (let i = this.sortedPointsData.length - 2; i >= index; i--) {
        balance += parseFloat(this.sortedPointsData[i].total_points);
      }

      return balance;
    },

    async submitPointsExchange() {
      if (this.isSubmitting) return;

      const ufsPoints = this.pointsToTradeUfs || 0;
      const olaPoints = this.pointsToTradeOla || 0;

      // Only proceed if at least one is valid
      if (ufsPoints < 2000 && olaPoints < 2000) {
        this.showFeedbackModal(
          "Aviso",
          "Deve submeter no mínimo 2000 pontos em pelo menos uma das categorias (UFS ou OLA).",
          true
        );
        return;
      }
      const formData = new FormData();
      formData.append("points_ufs", ufsPoints);
      formData.append("points_ola", olaPoints);
      formData.append("dsr_id", this.dsr_id);

      this.isSubmitting = true;

      try {
        const response = await axios.post(
          `app/createRequisition/${ufsPoints},${olaPoints}`,
          formData
        );

        if (response.data.success) {
          console.log("Response from server:", response.data);
          this.showFeedbackModal("Sucesso", "Troca submetida com sucesso");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          this.showFeedbackModal(
            "Erro",
            "Erro ao efetuar a troca de pontos. Tente novamente!",
            true
          );
        }
      } catch (error) {
        console.error("Erro ao submeter:", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
          console.error("Status code:", error.response.status);
        }
        this.showFeedbackModal(
          "Erro",
          "Ocorreu um erro ao submeter a troca de pontos.",
          true
        );
      } finally {
        // ✅ Re-enable button only if you don't refresh the page
        // (Optional: keep this if you remove the reload)
        this.isSubmitting = false;
      }
    },

    showFeedbackModal(title, message, isError = false) {
      this.feedbackTitle = title;
      this.feedbackMessage = message;
      this.isErrorFeedback = isError;
      this.isFeedbackModalOpen = true;
    },

    clearFormData() {
      this.message = "";
      this.image = null;
      this.fileName = "";
    },

    fetchDsrId() {
      this.loading = true;
      this.error = null;
      this.dsr_id = null;
      this.dsr_payment_method = null;

      this.axios
        .get("app/getDsrId")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.dsr_id = response.data.dsr_id;
          this.dsr_payment_method = response.data.payment_method;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    fetchName() {
      this.loading = true;
      this.error = null;
      this.user = null;
      this.user_id = null;

      this.axios
        .get("app/getInfo")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.user = response.data.name;
          this.user_id = response.data.user;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.icon-size {
  width: 40px;
}

.flex-container-emissao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 15px;
}

#no-pad-left {
  padding-left: 0px;
  padding-bottom: 15px;
}

.text {
  flex-grow: 1;
  text-align: left;
  color: #fff;
  font-size: 18px;
}

.icon img {
  width: 40px;
}

p {
  font-size: 18px;
}

.spinner {
  width: 80px;
  height: 80px;
  text-align: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

.text-confirmation {
  color: orange;
}

.text-danger {
  color: red;
}

.text-success {
  color: green;
}

.text-replaced {
  color: rgb(0, 255, 255);
}

.text-warning {
  color: orange;
}

.bold {
  font-weight: 500;
}

.error {
  color: red;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 30px 0px 10px 0px;
  scrollbar-width: none !important;
  /* Oculta a barra de rolagem */
}

#app::-webkit-scrollbar {
  display: none !important;
  /* Para Chrome, Safari e outros navegadores baseados em WebKit */
}

#form-contact .form-group {
  margin-bottom: 15px;
}

.points-container {
  display: flex;
}

#form-contact .form-name {
  width: 100%;
  /* padding: 10px; */
  font-size: 14px;
  min-height: 5vh;
  max-height: 5vh;
}

#form-contact .form-anexo {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  height: auto;
  min-height: 2vh;
}

#form-contact .btn {
  padding: 10px 20px;
  font-size: 14px;
}

#form-contact .btn-delete {
  color: white;
  background-color: red;
  border: 0px;
  border-radius: 4px;
  font-size: 14px;
}

#form-contact .form-nome {
  margin-top: -10px;
}

#form-contact .modal-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 500px;
  width: 90%;
  margin: auto;
}

#form-contact .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#form-contact .modal-title {
  margin: 0;
}

#form-contact .close {
  cursor: pointer;
}

#form-contact .modal-body {
  padding: 0 0;
  padding-top: 20px;
}

#form-contact h2 {
  font-size: 16px;
  margin-top: 5px;
}

#align-center {
  text-align: left;
}

.close-request {
  font-size: 18px !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#form-contact .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 500px;
  width: 90%;
  margin: auto;
}

#form-contact .close-btn {
  color: #c26e00;
  border: none;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: none;
  cursor: pointer;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .border-box {
  border: 1px solid #e4e7ea;
  border-radius: 5px;
  padding: 10px;
  /*background-color: #f8f9fa;*/
  margin-bottom: 20px;
  font-size: 16px;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.intro h2 {
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
}

#movpoints .card {
  /* width: 300px; */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

#movpoints .card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#movpoints .card-list {
  display: block;
  width: 100%;
}

#container-contact {
  background: linear-gradient(240.74deg, #c26e00 0%, #af3f00 100%);
  border-radius: 15px;
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
}

#container-contact .contact-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

#container-contact .message-section {
  flex: 1;
  /*padding-right: 20px;*/
  padding: 5px 5px 5px 5px;
}

#container-contact .image-section {
  /*flex: 0.3;
  text-align: right;*/
  width: max-content;
}

#container-contact .image-section img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

#container-contact .btn-primary {
  background-color: #fff;
  color: #f48c4f;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  border-radius: 10px;
}

#container-contact .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

#form-contact .btn-primary {
  background-color: #f48c4f;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 100%;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

#form-contact .btn-primary:hover {
  background-color: #c26e00;
  color: #fff;
}

#container-contact h2 {
  color: #fff;
  font-size: 16px;
}

#container-contact p {
  color: #666;
  font-size: 16px;
}

#container-contact .button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

#form-feedback .modal-content {
  background-color: #fff;
  /* padding: 20px; */
  border-radius: 8px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

#form-feedback .modal-content h2 {
  margin-top: 0;
  align-items: center;
}

#form-feedback .btn {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #f48c4f;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#form-feedback .btn:hover {
  background-color: #c26e00;
  color: #fff;
}

#download .title {
  margin-top: 20px;
  margin-bottom: 20px;
}

#download .btn-primary {
  background-color: #fff;
  color: #c26e00;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 60%;
  margin-top: 30px;
  text-transform: uppercase;
  margin-left: 20%;
  margin-right: 20%;
  margin-bottom: 30px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

#download .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

/* @media (max-width: 767px) {
  body {
    overflow-y: auto !important;
    height: 100vh; 
    scrollbar-width: none !important; 
  }
  
  body::-webkit-scrollbar {
    display: none !important; 
  }
} */
.red {
  color: red;
}

.green {
  color: #00c939;
}

.yellow {
  color: orange;
}

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  /* Garante que ocupe toda a altura da tela */
}

.modal-h3 {
  background-color: white;
  /* padding: 20px; */
  /* border-radius: 10px; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */
  /* max-width: 80%; */
  text-align: center;
}

.modal-p {
  color: rgb(0, 0, 0);
  text-align: center;
  /* margin-bottom: 20px; */
}

.btn-close {
  background-color: orange;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.btn-close:hover {
  background-color: #e96d2f;
}

#ufsInput,
#olaInput {
  height: 40px;
  display: block;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #c26e00;
  font-size: large;
}

.input {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
</style>
